import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled, Typography, useMediaQuery, useTheme } from "@mui/material";
import { isNotUndefinedOrNull } from "../../FunctionsCore";
import ThemeProvider from "../../theme";
import { palette, PRIMARY, SPACING } from "../../theme/palette";
import { ButtonStyle, Top } from "./styles";
const defaultMobileBreakpoint = 992;
const Container = styled("div")(() => ({
    "alignItems": "flex-start",
    "display": "flex",
    "flex": "0 1 0",
    "flexDirection": "column",
    "gap": SPACING.space2xsxs
}));
const Count = styled("div")(({ theme }) => (Object.assign({ "color": theme.palette.grey[900] }, theme.typography.subtitle2)));
const Heading = styled(Typography)(() => ({
    "a &": {
        "textDecoration": "underline"
    },
    "a:hover &": {
        "textDecoration": "none"
    },
    "color": palette.primary.main
}));
const Result = styled("div")(() => ({
    "alignItems": "flex-start",
    "display": "flex",
    "flexDirection": "column",
    "gap": SPACING.space3xs,
    "paddingBlock": SPACING.space3xs2xs
}));
const Description = styled(Typography)(() => ({
    "color": PRIMARY.grayPrimary
}));
const ResultsComponent = (props) => {
    const { handleSearchResultClick, mobileBreakpoint = defaultMobileBreakpoint, mobileFiltersOpen = false, setMobileFiltersOpen, siteSearchResponse } = props;
    const { keyword, siteContentCards, totalMatchedResults } = siteSearchResponse;
    const openMobileFilters = () => {
        if (isNotUndefinedOrNull(setMobileFiltersOpen)) {
            setMobileFiltersOpen(true);
        }
    };
    const theme = useTheme();
    const mobile = !useMediaQuery(theme.breakpoints.up(mobileBreakpoint));
    return (_jsx(ThemeProvider, { children: isNotUndefinedOrNull(mobileFiltersOpen) && mobileFiltersOpen && mobile ?
            _jsx(_Fragment, {})
            :
                _jsxs(Container, { children: [_jsxs(Top, { children: [_jsx(Count, { children: `${totalMatchedResults} results` }), !mobile ?
                                    _jsx(_Fragment, {})
                                    :
                                        _jsx(ButtonStyle, Object.assign({ onClick: openMobileFilters }, { children: "Filters" }))] }), siteContentCards.map(siteContentCard => {
                            const handleSearchResultsClickArguments = {
                                "addSearchResultInfo": {
                                    "documentId": siteContentCard.documentId,
                                    "keyword": keyword,
                                    "position": siteContentCard.position
                                }
                            };
                            return (_jsxs(Result, Object.assign({ isMobile: mobile }, { children: [_jsx("a", Object.assign({ href: siteContentCard.href, onKeyUp: () => isNotUndefinedOrNull(handleSearchResultClick) ? handleSearchResultClick(handleSearchResultsClickArguments) : {}, onPointerDown: () => isNotUndefinedOrNull(handleSearchResultClick) ? handleSearchResultClick(handleSearchResultsClickArguments) : {} }, { children: _jsx(Heading, Object.assign({ isMobile: mobile, variant: "h5" }, { children: siteContentCard.title })) })), _jsx(Description, Object.assign({ variant: "body1" }, { children: siteContentCard.description }))] }), siteContentCard.title));
                        })] }) }));
};
export { ResultsComponent };
